/**
 * O que esta organização licenciou.
 *
 * A navegação usa isto para **não oferecer** o que o cliente não contratou: um módulo sem
 * licença some do menu em vez de aparecer e devolver 402 no clique. A diferença é a mesma
 * de sempre — "você não contratou isto" é uma ligação para o comercial, "deu erro" é uma
 * para o suporte.
 *
 * Esconder não é a proteção: quem garante é o `exigir_modulo` no servidor. Aqui é para a
 * tela não ensinar que erro é normal.
 */
import { useEffect, useState } from "react";

import { api } from "../api/cliente";

interface ModuloDisponivel {
  codigo: string;
  licenciado: boolean;
}

export function useModulos(): { licenciados: string[]; carregando: boolean } {
  const [licenciados, definirLicenciados] = useState<string[]>([]);
  const [carregando, definirCarregando] = useState(true);

  useEffect(() => {
    let vivo = true;
    void api<ModuloDisponivel[]>("/modulos")
      .then((modulos) => {
        if (!vivo) return;
        definirLicenciados(
          modulos.filter((m) => m.licenciado).map((m) => m.codigo),
        );
      })
      // Falhar aqui não pode esvaziar o menu: uma rede instável deixaria o operador sem
      // navegação nenhuma, sem nada na tela explicando por quê. Sem resposta, o menu
      // mostra tudo e quem recusa é o servidor, com a frase certa.
      .catch(() => {
        if (vivo) definirLicenciados(["analise", "tollvision", "whatsbi"]);
      })
      .finally(() => {
        if (vivo) definirCarregando(false);
      });
    return () => {
      vivo = false;
    };
  }, []);

  return { licenciados, carregando };
}
